module.exports = __webpack_public_path__ + "static/media/bp5.6536aae8.jpg";